import { GridRowId } from '@mui/x-data-grid';

import { _request, APIBaseResponse, APIMethod } from '../';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const ROLES_PATH_PREFIX = 'roles';

type APIRoleGetParams = {
    tenantId: string;
    id: string;
};

export type Role = {
    tenantId: string;
    id: string;
    name: string;
}

export type APIRoleGetResponse = APIBaseResponse<Role>;

export const APIRoleGet: APIMethod<APIRoleGetParams, APIRoleGetResponse> = (params: APIRoleGetParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLES_PATH_PREFIX}/${params.id}`)
);

type APIRolesGetParams = RequestParamsBase & {
    tenantId: string;
};

type APIRolesGetResponse = APIBaseResponse<Array<Role>>;

export const APIRoleGetList: APIMethod<APIRolesGetParams, APIRolesGetResponse> = (params: APIRolesGetParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLES_PATH_PREFIX}`, undefined, params.signal));

export type APIRolePostParams = {
    name: string;
    tenantId: string;
};

export type APIRolePutParams = {
    name: string;
    id: GridRowId;
    tenantId: string;
};

type APIRoleDeleteParams = {
    id: string;
    tenantId: string;
};

export type APIRolePostResponse = APIBaseResponse<{ roleId: string }>;
type APIRoleDeleteResponse = APIBaseResponse<''>;

export const APIRolePost: APIMethod<APIRolePostParams, APIRolePostResponse> = (params) => (
    _request<APIRolePostResponse>('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLES_PATH_PREFIX}`, {
        name: params.name,
        tenantId: params.tenantId,
    })
);

export const APIRoleDelete: APIMethod<APIRoleDeleteParams, APIRoleDeleteResponse> = (params: APIRoleDeleteParams) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLES_PATH_PREFIX}/${params.id}`));

export const APIRolePut: APIMethod<APIRolePutParams, APIBaseResponse> = (params) => (
    _request<APIBaseResponse>('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ROLES_PATH_PREFIX}/${params.id}`, {
        id: params.id,
        name: params.name,
        tenantId: params.tenantId,
    })
);
